<template>
  <div class="first-column-header-icons-container">
    <img
      v-if="tableCanExpand"
      :src="PlusIcon"
      :alt="$t('sbTable.expandAllRows')"
      class="expand-all-icons"
      @click="expandAll"
    >
    <img
      v-if="tableCanExpand"
      :src="MinusIcon"
      :alt="$t('sbTable.collapseAllRows')"
      class="expand-all-icons"
      @click="collapseAll"
    >
    <SbCheckbox
      v-if="canMultiSelect"
      v-model:checked="checked"
      class="checkbox-select-all"
      :indeterminate="someSelected"
    />
  </div>
</template>
<script>
import PlusIcon from '@public/media/icons/plus.svg';
import MinusIcon from '@public/media/icons/minus.svg';
import SbCheckbox from '@src/components/Checkbox/SbCheckbox.vue';

export default {
  name: 'ExpandCollapseAll',
  components: {
    SbCheckbox,
  },
  props: {
    table: {
      type: Object,
      default: () => ({}),
    },
    /** If there is a nested table that is selectable */
    hasSubSelectableTable: {
      type: Boolean,
      default: false,
    },
    /**
    * Whether the expand/collapse icons should appear or not.
    */
    tableCanExpand: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    /**
    * Emitted when a change in row selection happens
    */
    'row-selection-updated',
  ],
  data: () => ({
    PlusIcon,
    MinusIcon,
  }),
  computed: {
    canMultiSelect() {
      return this.table.options?.enableRowSelection;
    },
    someSelected() {
      return this.table.getIsSomeRowsSelected();
    },
    allSelected() {
      return this.table.getIsAllRowsSelected();
    },
    checked: {
      get() {
        return this.someSelected || this.allSelected;
      },
      set() {
        this.toggleSelectAll();
      },
    },
  },
  methods: {
    expandAll() {
      this.table.setExpanded(true);
    },
    collapseAll() {
      this.table.setExpanded(false);
    },
    toggleSelectAll() {
      this.table.toggleAllRowsSelected(!this.checked);

      if (!this.hasSubSelectableTable) {
        this.table.toggleAllRowsExpanded(!this.checked);
      }

      this.$emit('row-selection-updated');
    },
  },
};
</script>
